module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/asset/searchIcon.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/asset/searchIcon.png
// module id = 1042
// module chunks = 367